function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var NavTemplate = require('./nav.template');
var ArcadeNav = /*#__PURE__*/function () {
  function ArcadeNav(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.arcade-nav';
    _classCallCheck(this, ArcadeNav);
    this.app = app;
    this.mod = mod;
    this.container = container;
  }
  return _createClass(ArcadeNav, [{
    key: "render",
    value: function render() {
      var root = document.querySelector(this.container);
      if (!root) {
        return;
      }
      root.innerHTML = NavTemplate(this);
      this.attachEvents();
    }
  }, {
    key: "setActive",
    value: function setActive(activeItem) {
      var root = document.querySelector(this.container);
      if (!root) {
        return;
      }
      root.querySelectorAll('.item').forEach(function (item) {
        item.classList.toggle('active', item === activeItem);
      });
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var root = document.querySelector(this.container);
      if (!root) {
        return;
      }
      var home = root.querySelector('[data-nav="home"]');
      var settings = root.querySelector('[data-nav="settings"]');
      if (home) {
        home.onclick = function (e) {
          e.preventDefault();
          var anchor = document.getElementById('top-of-game-list');
          if (anchor) {
            anchor.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
          _this.setActive(home);
        };
      }
      if (settings) {
        settings.onclick = function (e) {
          var _this$mod;
          e.preventDefault();
          _this.setActive(settings);
          if ((_this$mod = _this.mod) !== null && _this$mod !== void 0 && _this$mod.settings_overlay) {
            _this.mod.settings_overlay.render();
          }
        };
      }
    }
  }]);
}();
module.exports = ArcadeNav;